/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Titles_Contactus1Inputs */

const en_titles_contactus1 = /** @type {(inputs: Titles_Contactus1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact us`)
};

/**
* | output |
* | --- |
* | "Contact us" |
*
* @param {Titles_Contactus1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const titles_contactus1 = /** @type {((inputs?: Titles_Contactus1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Titles_Contactus1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_titles_contactus1(inputs)
});
export { titles_contactus1 as "titles_contactUs" }